import React from 'react';
import makePath from '../../utils/makePath';
import { TextInput, RichTextEditor } from '../EditorFormElements';
import { FormFieldWrapper } from '../Global';

export const AttentionText = React.memo((props) => {
  const path = makePath(props.path,'attention');
  const { given = {} } = props;

  return (
    <>
      <h4 className="form-section-header">Instructions</h4>

      <FormFieldWrapper>
              
        <TextInput 
          name='title'
          label='Instruction Headline'
          defaultText="Enter headline text here"
          given={given.title}
          path={path}
        />

        <RichTextEditor 
          name='instr'
          // label='Instructions'
          defaultValue="<p>Enter body text for the instructions</p>"
          controls={[]}
          inlineToolbarControls={false}
          given={given.instr}
          path={path}
        />

      </FormFieldWrapper>
    </>
  )
})